import * as Types from '../constants/actionTypes';
const defaultState = {
    servicetypelist: []
}
export default (state = defaultState, action) => {
    switch (action.type) {
        /* Box Details States */
        case Types.GET_SERVICE_TYPE:
            return {
                ...state,
                servicetypelist: action.payload
            }
        case Types.SERVICE_TYPE_COUNT_SUCCESS:
                return {
                    ...state,
                    serviceTypeListCount: action.payload
                }
        case Types.ADD_SERVICE_TYPE:
               state.servicetypelist.push(action.payload)
            return {
                ...state
                }
        case Types.DELETE_SERVICE_TYPE:
            if(action.deleteIndex) {
                state.servicetypelist.splice(action.deleteIndex, 1);
            }
            return {
                ...state,
                // deletedStatus: action.payload,
            }

        case Types.UPDATE_SERVICE_TYPE:
            const updatePresentData = state.servicetypelist
            if(state.servicetypelist) {
                updatePresentData[action.updateIndex] = action.updatedServiceType
            }
            return {
                ...state,
                servicetypelist: updatePresentData
            }
        case Types.SERVICE_TYPE_ERROR:
            return {
                ...state,
                serviceTypeError: action.payload
            }
        default:
            return state
    }
}
